import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    fullName,
    signer,
    certificate,
    timeSign,

    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,

    taxpayerName,
    taxpayerCountry,
    taxpayerAddress,

    capitalTransfereeName,
    capitalTransfereeCountry,
    capitalTransfereeAddress,
    capitalTransfereeTaxId,

    taxAgentName,
    taxAgentId,

    enterprisesTransferredName,
    enterprisesTransferredTaxId,

    contractNumber,
    contractDay,
  },
} = checkout;

const validation = Yup.object().shape({
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [taxpayerCountry.name]: Yup.string().required(taxpayerCountry.errorMsg),
  [taxpayerAddress.name]: Yup.string().required(taxpayerAddress.errorMsg),
  [capitalTransfereeName.name]: Yup.string().required(capitalTransfereeName.errorMsg),
  [capitalTransfereeCountry.name]: Yup.string().required(capitalTransfereeCountry.errorMsg),
  [capitalTransfereeAddress.name]: Yup.string().required(capitalTransfereeAddress.errorMsg),
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [enterprisesTransferredName.name]: Yup.string().required(enterprisesTransferredName.errorMsg),

  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [contractNumber.name]: Yup.number().required(contractNumber.errorMsg),
  [contractDay.name]: Yup.number().required(contractDay.errorMsg),

  [capitalTransfereeTaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, capitalTransfereeTaxId.invalidMsg)
    .notRequired(capitalTransfereeTaxId.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),
  [enterprisesTransferredTaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, enterprisesTransferredTaxId.invalidMsg)
    .notRequired(enterprisesTransferredTaxId.errorMsg),

  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
});

export default validation;
